<template>
  <div class="calendar">
    <h2>Select your appointment</h2>
    <div class="details-form-row">
      <datepicker :disabled-dates="disabledDates" @selected="selectDate" placeholder="Select a date "
                  v-model="formDataStore.formData.bookingCalendar.date"></datepicker>
    </div>
    <div class="details-form-row" v-if="times">
      <Dropdown v-if="times.length > 0" :value="formDataStore.formData.bookingCalendar.time"
                @change="selectTime" :options="times" label="duration">
      </Dropdown>
      <h3 v-if="times.length === 0" class="ircc-blue">There are no available times for the selected date</h3>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Dropdown from './Dropdown.vue';
import {mapStores} from "pinia";
import {BookingCalendarStore} from "../stores/BookingCalendarStore";
import {FormDataStore} from "../stores/FormDataStore";

export default {
    name: 'Calendar',
    components: {
        Datepicker,
        Dropdown
    },
    computed: {
      ...mapStores(FormDataStore, BookingCalendarStore),
    },
  data: function () {
    return {
      times: null,
      disabledDates: {
        to: new Date(),
      },
    }
  },
  methods: {
    async selectDate(selectedDate) {
      this.formDataStore.formData.bookingCalendar.time = null;
      this.times = null;
      var date = new Date(selectedDate);
      this.formDataStore.formData.bookingCalendar.date = date;

      try {
        const times = await this.bookingCalendarStore.getTimes({
          location: this.formDataStore.formData.location.location,
          date: selectedDate,
          sessionCategory: this.formDataStore.formData.sessionCategory.sessionCategory
        });

        this.times = times
            .filter((time) => time.available)
            .map((time) => ({
              startDateTime: time.startDateTime,
              endDateTime: time.endDateTime,
              duration: [new Date(time.startDateTime).toLocaleTimeString("en-UK"), new Date(time.endDateTime).toLocaleTimeString("en-UK")].join(" - ")
            }));
      } catch (error) {
          this.formDataStore.error = true;
      }
    },
    selectTime(selectedTime) {
      this.formDataStore.formData.bookingCalendar.time = selectedTime;
    }
  }
}
</script>

<style>
.vdp-datepicker__calendar .cell {
  float: left;
}
</style>